// Logotype логотип для главного экрана
export function Logotype() {
    const style = "flex justify-center items-center p-1 md:p-2 border-solid border-2 border-gray-100/50 rounded bg-gray-800 uppercase h-[26px] w-[26px] md:h-[32px] md:w-[32px] bg-yellow-300 text-gray-800 text-sm md:text-base";
    return (
        <div className={"flex w-full justify-center items-center z-10"}>
            <div className={"flex flex-col md:flex-row w-full gap-[2px] md:gap-1"}>
                <div className={"flex gap-[2px] md:gap-1"}>
                    <div className={style}>W</div>
                    <div className={style}>O</div>
                    <div className={style}>R</div>
                    <div className={style}>D</div>
                </div>
                <div className={"flex gap-[2px] md:gap-1 mt-1 md:m-0"}>
                    <div className={style}>M</div>
                    <div className={style}>A</div>
                    <div className={style}>N</div>
                    <div className={style}>I</div>
                    <div className={style}>A</div>
                </div>
            </div>
        </div>
    );
}
